import { Box, Tooltip } from "@mui/material";

import { CALIBRATE_FONT_FAMILY_DISPLAY } from "components/hoc/Theme";

import { avatarFill, avatarTooltip, type AvatarPerson } from "./avatarModel";

interface UserAvatarProps {
  person: AvatarPerson;
  size?: number;
}

/** A person's initials on their colour: a circle for staff, a rounded square for
 * client users, with a white outline so stacked avatars stay apart. */
export default function UserAvatar({ person, size = 24 }: UserAvatarProps) {
  const label = avatarTooltip(person);
  return (
    <Tooltip title={label} arrow>
      <Box
        component="span"
        role="img"
        aria-label={label}
        sx={{
          width: size,
          height: size,
          flexShrink: 0,
          boxSizing: "border-box",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius:
            person.shape === "circle" ? "50%" : `${Math.round(size / 4)}px`,
          border: "1.5px solid #FFFFFF",
          bgcolor: avatarFill(person.color),
          color: "#FFFFFF",
          fontFamily: CALIBRATE_FONT_FAMILY_DISPLAY,
          fontSize: Math.max(9, Math.round(size * 0.38)),
          fontWeight: 700,
          lineHeight: 1,
          userSelect: "none",
        }}
      >
        {person.initials}
      </Box>
    </Tooltip>
  );
}
